import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{discourse-tag this.rowValue count=this.item.count noHref=true}}", {
  moduleName: "select-kit/components/tag-chooser-row.hbs"
});